<template>
    <main class="home">
        <section
            class="hero"
            style="background-image: url(/images/home_bg.jpg)"
        >
            <div class="hero__layer"></div>

            <div class="hero__top hero__top--home">
                <div class="container">
                    <div class="hero__top__inner hero__top__inner--center">
                        <div class="hero__top__block hero__top__block--home">
                            <h1 class="hero__top__title">
                                Πόθεν Έσχες Βουλευτών
                            </h1>
                            <h2 class="hero__top__subtitle">
                                Τo Vouliwatch συλλέγει και συγκρίνει τα
                                περιουσιακά στοιχεία των Ελλήνων βουλευτών.
                            </h2>
                        </div>
                        <div class="hero__top__block hero__top__block--home">
                            <img src="/images/top-icon.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="hero__main">
                <div class="container">
                    <div class="hero__main__inner">
                        <div class="hero__main__block">
                            <div class="hero__main__block__top">
                                <div class="hero__main__block__top__group">
                                    <div
                                        class="drop-down-filter drop-down-filter--large"
                                    >
                                        <div class="toggle toggle--border">
                                            <span>{{ activeTop10.label }}</span>
                                            <i class="fa fa-chevron-down"></i>
                                        </div>
                                        <ul>
                                            <li
                                                v-for="option in top10options"
                                                v-bind:key="option.value"
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        setTop10(option)
                                                    "
                                                    :class="{
                                                        active:
                                                            option.label ==
                                                            activeTop10.label,
                                                    }"
                                                    >{{ option.label }}</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="hero__main__block__top__group">
                                    <div
                                        class="drop-down-filter drop-down-filter--border drop-down-filter--right"
                                    >
                                        <div class="toggle">
                                            <span>{{ activeTop10.year }}</span>
                                            <i class="fa fa-chevron-down"></i>
                                        </div>
                                        <ul>
                                            <li
                                                v-for="(
                                                    year, key
                                                ) in availableYears"
                                                v-bind:key="
                                                    key + 'left_dropdown'
                                                "
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        setTop10Year(year)
                                                    "
                                                    :class="{
                                                        active:
                                                            year ==
                                                            activeTop10.year,
                                                    }"
                                                    >{{ year }}</a
                                                >
                                            </li>
                                            <!-- <li><hr></li>
                      <li><a href="/parliament/gr/ii-17-07-2019?group="> <span>IZ'</span> <span>30 • 10  • 2015 - 11 • 6  • 2019</span> </a></li> -->
                                        </ul>
                                    </div>

                                    <div
                                        class="drop-down-filter drop-down-filter--radius"
                                    >
                                        <div
                                            class="toggle desktop"
                                            v-show="false"
                                        >
                                            <span>ΛΗΨΗ</span>
                                        </div>
                                        <ul>
                                            <li>
                                                <a
                                                    href="/parliament/gr/ii-17-07-2019?group="
                                                    >ΑΡΧΕΙΟ PDF
                                                    <i
                                                        class="fa fa-file-pdf-o"
                                                    ></i
                                                ></a>
                                            </li>
                                            <li>
                                                <a
                                                    href="/parliament/gr/ii-17-07-2019?group="
                                                    >ΑΡΧΕΙΟ PNG
                                                    <i
                                                        class="fa fa-file-image-o"
                                                    ></i
                                                ></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="top10" v-if="activeTop10.data">
                                <!-- <transition-group name="list" tag="div" mode="out-in"> -->
                                <div
                                    class="top10__row"
                                    v-for="(item, index) in activeTop10.data"
                                    v-bind:key="item.id"
                                >
                                    <div class="top10__row__number">
                                        {{ index + 1 }}
                                    </div>
                                    <div class="top10__row__bar">
                                        <div
                                            class="top10__row__bar__inner"
                                            :style="{
                                                width:
                                                    top10BarWidth(
                                                        item.properties_count
                                                            ? item.properties_count
                                                            : item.total
                                                    ) + '%',
                                            }"
                                        >
                                            <div
                                                class="top10__row__bar__icon photo-icon"
                                                :style="{
                                                    backgroundImage:
                                                        'url(' +
                                                        item.member
                                                            .profile_image +
                                                        ')',
                                                }"
                                            ></div>
                                            <router-link
                                                :to="{
                                                    path:
                                                        '/' + item.member.slug,
                                                    query: {
                                                        year: activeTop10.year,
                                                    },
                                                }"
                                                class="top10__row__bar__wrapper"
                                            >
                                                <p
                                                    class="top10__row__bar__name"
                                                    v-if="!item.member.eu"
                                                >
                                                    <strong
                                                        >{{
                                                            item.member
                                                                .last_name
                                                        }}
                                                        {{
                                                            item.member
                                                                .first_name
                                                        }}</strong
                                                    ><span
                                                        v-if="
                                                            item.parliament_group
                                                        "
                                                        >{{
                                                            item
                                                                .parliament_group
                                                                .short_name
                                                                ? item
                                                                      .parliament_group
                                                                      .short_name
                                                                : item
                                                                      .parliament_group
                                                                      .name
                                                        }}</span
                                                    >
                                                </p>
                                                <p
                                                    class="top10__row__bar__name"
                                                    v-if="item.member.eu"
                                                >
                                                    <strong
                                                        >{{
                                                            item.member
                                                                .last_name
                                                        }}
                                                        {{
                                                            item.member
                                                                .first_name
                                                        }}</strong
                                                    ><span
                                                        v-if="
                                                            item.politicalparty
                                                        "
                                                        >{{
                                                            item.politicalparty
                                                                .short_name
                                                                ? item
                                                                      .politicalparty
                                                                      .short_name
                                                                : item
                                                                      .politicalparty
                                                                      .name
                                                        }}</span
                                                    >
                                                </p>
                                            </router-link>
                                            <span
                                                class="top10__row__bar__amount"
                                                v-if="item.total"
                                                >{{
                                                    Number(
                                                        item.total
                                                    ).toLocaleString()
                                                }}
                                                €</span
                                            >
                                            <span
                                                class="top10__row__bar__amount"
                                                v-else
                                                >{{
                                                    item.properties_count
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <!-- </transition-group> -->
                            </div>
                        </div>

                        <div class="hero__main__block">
                            <div class="hero__main__block__top">
                                <div class="hero__main__block__top__group">
                                    <div
                                        class="drop-down-filter drop-down-filter--large"
                                    >
                                        <div class="toggle toggle--border">
                                            <span>{{
                                                active_parties_avg.label
                                            }}</span>
                                            <i class="fa fa-chevron-down"></i>
                                        </div>
                                        <ul>
                                            <li
                                                v-for="option in parties_average_options"
                                                v-bind:key="option.value"
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        setActivePartyAvg(
                                                            option
                                                        )
                                                    "
                                                    :class="{
                                                        active:
                                                            option.label ==
                                                            active_parties_avg.label,
                                                    }"
                                                    >{{ option.label }}</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="hero__main__block__top__group">
                                    <div
                                        class="drop-down-filter drop-down-filter--border drop-down-filter--right"
                                    >
                                        <div class="toggle">
                                            <span>{{
                                                active_parties_avg.year
                                            }}</span>
                                            <i class="fa fa-chevron-down"></i>
                                        </div>
                                        <ul>
                                            <li
                                                v-for="(
                                                    year, key
                                                ) in availableYears"
                                                v-bind:key="
                                                    key + 'left_dropdown'
                                                "
                                            >
                                                <a
                                                    href="#"
                                                    @click.prevent="
                                                        setActivePartyYear(year)
                                                    "
                                                    :class="{
                                                        active:
                                                            year ==
                                                            active_parties_avg.year,
                                                    }"
                                                    >{{ year }}</a
                                                >
                                            </li>
                                        </ul>
                                    </div>

                                    <div
                                        class="drop-down-filter drop-down-filter--radius"
                                    >
                                        <div
                                            class="toggle desktop"
                                            v-show="false"
                                        >
                                            <span>ΛΗΨΗ</span>
                                        </div>
                                        <ul>
                                            <li>
                                                <a
                                                    href="/parliament/gr/ii-17-07-2019?group="
                                                    >ΑΡΧΕΙΟ PDF
                                                    <i
                                                        class="fa fa-file-pdf-o"
                                                    ></i
                                                ></a>
                                            </li>
                                            <li>
                                                <a
                                                    href="/parliament/gr/ii-17-07-2019?group="
                                                    >ΑΡΧΕΙΟ PNG
                                                    <i
                                                        class="fa fa-file-image-o"
                                                    ></i
                                                ></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <parties-chart
                                :active="active_parties_avg"
                                :data="parties_average"
                            ></parties-chart>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="home__table">
            <div class="container">
                <div class="home__table__top">
                    <h3 class="home__table__top__title">
                        Δηλώσεις πόθεν έσχες βουλευτών
                    </h3>
                    <router-link
                        :to="{ path: '/compare' }"
                        class="btn btn--std"
                    >
                        ΣΥΓΚΡΙΣΗ
                    </router-link>
                </div>

                <div class="home__table__search">
                    <member-autocomplete></member-autocomplete>
                    <!-- <form class="search-input">
            <input type="search" placeholder="Αναζήτησε" id="search-query">
            <button type="submit" disabled="disabled"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" width="32.873px" height="32.874px" viewBox="0 0 32.873 32.874" enable-background="new 0 0 32.873 32.874" xml:space="preserve"><g><path d="M12.849,25.695C5.764,25.695,0,19.932,0,12.848C0,5.763,5.764,0,12.849,0c7.084,0,12.848,5.763,12.848,12.848C25.696,19.932,19.933,25.695,12.849,25.695z M12.849,2C6.866,2,2,6.866,2,12.848s4.866,10.848,10.849,10.848c5.981,0,10.848-4.866,10.848-10.848S18.83,2,12.849,2z"></path> <rect x="18.87" y="25.658" transform="matrix(0.707 0.7072 -0.7072 0.707 26.664 -11.0429)" width="15.578" height="2"></rect></g></svg></button>
          </form> -->
                </div>

                <div class="home__table__filters">
                    <div class="home__table__filters__block">
                        <div class="drop-down-with-label">
                            <p class="drop-down-with-label__label">
                                ΕΤΟΣ ΧΡΗΣΗΣ
                            </p>
                            <div
                                class="drop-down-filter drop-down-filter--border"
                            >
                                <div class="toggle">
                                    <span>{{
                                        memberFilters.years | arrayToString
                                    }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul>
                                    <li>
                                        <!-- <input class="regular-checkbox" type="checkbox" id="years_all" value="all" @change="selectAllMemberYears($event)"> -->
                                        <label for="years_all"></label>
                                        <label
                                            for="years_all"
                                            @click="selectAllMemberYears()"
                                            >Όλα</label
                                        >
                                    </li>
                                    <li><hr /></li>
                                    <li
                                        v-for="(year, key) in availableYears"
                                        v-bind:key="key + 'member_years'"
                                    >
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            :id="'member_year_' + year"
                                            v-model="memberFilters.years"
                                            :value="year"
                                        />
                                        <label
                                            :for="'member_year_' + year"
                                        ></label>
                                        <label :for="'member_year_' + year">{{
                                            year
                                        }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- <div class="drop-down-with-label">
              <p class="drop-down-with-label__label">ΒΟΥΛΕΥΤΕΣ</p>
              <div class="drop-down-filter drop-down-filter--border">
                <div class="toggle"><span>{{memberFilters.members | arrayToStringMember(members_all)}}</span> <i class="fa fa-chevron-down"></i></div>
                <ul>
                  <li>
                    <label for="members_all"></label>
                    <label for="members_all" @click="selectAllMembers()">Όλοι</label>
                  </li>
                  <li><hr></li>
                  <li v-for="(member, key) in members_all" v-bind:key="key+'member_select'">
                    <input class='regular-checkbox' type="checkbox" :id="'member_select'+member.id" v-model="memberFilters.members" :value="member.id">
                    <label :for="'member_select'+member.id"></label>
                    <label :for="'member_select'+member.id">{{ `${member.last_name} ${member.first_name}`  }}</label>
                  </li>
                </ul>
              </div>
            </div> -->
                        <div class="drop-down-with-label">
                            <p class="drop-down-with-label__label">
                                ΚΟΙΝΟΒΟΥΛΙΟ
                            </p>
                            <div
                                class="drop-down-filter drop-down-filter--border"
                            >
                                <div class="toggle">
                                    <span>{{
                                        memberFilters.parliament_type
                                            | arrayToString()
                                    }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul>
                                    <li>
                                        <!-- <input class="regular-checkbox" type="checkbox" id="members_all" value="all" @change="selectAllMembers($event)"> -->
                                        <label for="members_all"></label>
                                        <label
                                            for="members_all"
                                            @click="selectAllParliamentTypes()"
                                            >Όλοι</label
                                        >
                                    </li>
                                    <li><hr /></li>
                                    <li>
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            id="parliament_greek"
                                            v-model="
                                                memberFilters.parliament_type
                                            "
                                            value="Ελληνικό κοινοβούλιο"
                                        />
                                        <label for="parliament_greek"></label>
                                        <label for="parliament_greek"
                                            >Ελληνικό κοινοβούλιο</label
                                        >
                                    </li>
                                    <li>
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            id="parliament_eu"
                                            v-model="
                                                memberFilters.parliament_type
                                            "
                                            value="Ευρωβουλή"
                                        />
                                        <label for="parliament_eu"></label>
                                        <label for="parliament_eu"
                                            >Ευρωβουλή</label
                                        >
                                    </li>
                                    <!-- <li><hr></li>
                  <li><a href="/parliament/gr/ii-17-07-2019?group="> <span>IZ'</span> <span>30 • 10  • 2015 - 11 • 6  • 2019</span> </a></li> -->
                                </ul>
                            </div>
                        </div>

                        <div class="drop-down-with-label">
                            <p class="drop-down-with-label__label">
                                ΚΟΙΝΟΒ. ΟΜΑΔΕΣ
                            </p>
                            <div
                                class="drop-down-filter drop-down-filter--border"
                            >
                                <div class="toggle">
                                    <span>{{
                                        memberFilters.political_parties
                                            | arrayToStringPP(political_parties)
                                    }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul>
                                    <li>
                                        <!-- <input class="regular-checkbox" type="checkbox" id="parties_all" value="all" @change="selectAllParties($event)"> -->
                                        <label for="parties_all"></label>
                                        <label
                                            for="parties_all"
                                            @click="selectAllParties()"
                                            >Όλες</label
                                        >
                                    </li>
                                    <li><hr /></li>
                                    <li
                                        v-for="(
                                            party, key
                                        ) in political_parties"
                                        v-bind:key="key + 'member_years'"
                                    >
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            :id="'member_party_' + party.id"
                                            v-model="
                                                memberFilters.political_parties
                                            "
                                            :value="party.id"
                                        />
                                        <label
                                            :for="'member_party_' + party.id"
                                        ></label>
                                        <label
                                            :for="'member_party_' + party.id"
                                            >{{ party.name }}</label
                                        >
                                    </li>
                                    <!-- <li><hr></li>
                  <li><a href="/parliament/gr/ii-17-07-2019?group="> <span>IZ'</span> <span>30 • 10  • 2015 - 11 • 6  • 2019</span> </a></li> -->
                                </ul>
                            </div>
                        </div>

                        <div class="drop-down-with-label">
                            <p class="drop-down-with-label__label">ΑΞΙΩΜΑ</p>
                            <div
                                class="drop-down-filter drop-down-filter--border"
                            >
                                <div class="toggle">
                                    <span>{{
                                        memberFilters.positions
                                            | arrayToStringPG(
                                                goverment_positions
                                            )
                                    }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul style="min-width: 230px">
                                    <li>
                                        <!-- <input class="regular-checkbox" type="checkbox" id="positions_all" value="all" @change="selectAllPositions($event)"> -->
                                        <label for="positions_all"></label>
                                        <label
                                            for="positions_all"
                                            @click="selectAllPositions()"
                                            >Όλα</label
                                        >
                                    </li>
                                    <li><hr /></li>
                                    <li
                                        v-for="(
                                            position, key
                                        ) in goverment_positions"
                                        v-bind:key="key + 'm_position_'"
                                        class="has-submenu"
                                        v-if="position.positions.length > 1"
                                    >
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            :id="'m_position_' + position.id"
                                            @change="
                                                positionGroupChechbox(
                                                    $event,
                                                    position
                                                )
                                            "
                                        />
                                        <label
                                            :for="'m_position_' + position.id"
                                        ></label>
                                        <label
                                            :for="'m_position_' + position.id"
                                            >{{ position.name }}</label
                                        ><a
                                            href="#"
                                            class="drop-down-with-label__toggle"
                                            ><i class="fa fa-chevron-down"></i
                                        ></a>
                                        <ul
                                            class="submenu"
                                            v-if="position.positions.length > 1"
                                        >
                                            <li
                                                v-for="(
                                                    pos, key
                                                ) in position.positions"
                                                v-bind:key="
                                                    key + 'mg_position_'
                                                "
                                            >
                                                <input
                                                    class="regular-checkbox"
                                                    type="checkbox"
                                                    :id="
                                                        'mg_position_' + pos.id
                                                    "
                                                    v-model="
                                                        memberFilters.positions
                                                    "
                                                    :value="pos.id"
                                                />
                                                <label
                                                    :for="
                                                        'mg_position_' + pos.id
                                                    "
                                                ></label>
                                                <label
                                                    :for="
                                                        'mg_position_' + pos.id
                                                    "
                                                    >{{ pos.name }}</label
                                                >
                                            </li>
                                        </ul>
                                    </li>
                                    <!-- <li><hr></li>
                  <li><a href="/parliament/gr/ii-17-07-2019?group="> <span>IZ'</span> <span>30 • 10  • 2015 - 11 • 6  • 2019</span> </a></li> -->
                                </ul>
                            </div>
                        </div>
                        <div class="drop-down-with-label">
                            <p class="drop-down-with-label__label">
                                ΚΟΙΝΟΒ. ΘΕΣΗ
                            </p>
                            <div
                                class="drop-down-filter drop-down-filter--border"
                            >
                                <div class="toggle">
                                    <span>{{
                                        memberFilters.parliamentOffices
                                            | arrayToStringPP(
                                                parliament_offices
                                            )
                                    }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul>
                                    <li>
                                        <!-- <input class="regular-checkbox" type="checkbox" id="positions_all" value="all" @change="selectAllPositions($event)"> -->
                                        <label for="positions_all"></label>
                                        <label
                                            for="positions_all"
                                            @click="
                                                selectAllParliamentOffices()
                                            "
                                            >Όλα</label
                                        >
                                    </li>
                                    <li><hr /></li>
                                    <li
                                        v-for="(
                                            position, key
                                        ) in parliament_offices"
                                        v-bind:key="key + 'm_pa_office_'"
                                    >
                                        <input
                                            class="regular-checkbox"
                                            type="checkbox"
                                            :id="'m_pa_office_' + position.id"
                                            v-model="
                                                memberFilters.parliamentOffices
                                            "
                                            :value="position.id"
                                        />
                                        <label
                                            :for="'m_pa_office_' + position.id"
                                        ></label>
                                        <label
                                            :for="'m_pa_office_' + position.id"
                                            >{{ position.name }}</label
                                        >
                                    </li>
                                    <!-- <li><hr></li>
                  <li><a href="/parliament/gr/ii-17-07-2019?group="> <span>IZ'</span> <span>30 • 10  • 2015 - 11 • 6  • 2019</span> </a></li> -->
                                </ul>
                            </div>
                        </div>
                        <a
                            href="#"
                            class="home__table__filters__reset"
                            v-if="
                                memberFilters.positions.length |
                                    memberFilters.members.length |
                                    memberFilters.political_parties.length |
                                    memberFilters.years.length
                            "
                            @click.prevent="resetFilters()"
                        >
                            <img src="/images/reset.svg" alt="" />
                        </a>
                    </div>

                    <div class="home__table__filters__block">
                        <div
                            class="drop-down-filter drop-down-filter--border drop-down-filter--right"
                        >
                            <div class="toggle">
                                <span>{{
                                    memberFilters.sort_by
                                        | arrayToStringSort(sort_by)
                                }}</span>
                                <i class="fa fa-chevron-down"></i>
                            </div>
                            <ul>
                                <li
                                    v-for="(sortby, key) in sort_by"
                                    v-bind:key="key + 'sort_by'"
                                    v-if="filterSortby(sortby.value)"
                                >
                                    <input
                                        class="regular-radio"
                                        type="radio"
                                        :id="'sort_by' + key"
                                        v-model="memberFilters.sort_by"
                                        :value="sortby.value"
                                    />
                                    <label :for="'sort_by' + key"></label>
                                    <label :for="'sort_by' + key">{{
                                        sortby.label
                                    }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="home__table__results">
                    <div
                        class="home__table__item"
                        v-for="(member, key) in displayedMembers"
                        v-bind:key="'member_' + key"
                    >
                        <router-link
                            :to="{
                                path: '/' + member.slug,
                                query: {
                                    year:
                                        member.fiscal.length &&
                                        member.fiscal[0].year_of_use,
                                },
                            }"
                            class="home__table__item__info"
                        >
                            <div
                                class="home__table__item__info__icon photo-icon photo-icon--80"
                                :style="{
                                    backgroundImage:
                                        'url(' +
                                        getProfileImage(member.profile_image) +
                                        ')',
                                }"
                            ></div>
                            <div class="home__table__item__info__block">
                                <p class="home__table__item__name">
                                    {{ member.last_name }}
                                </p>
                                <p class="home__table__item__name">
                                    {{ member.first_name }}
                                </p>
                                <p
                                    class="home__table__item__role"
                                    v-if="member.electoral_districts.length"
                                >
                                    {{ member.electoral_districts[0].name }}
                                </p>
                            </div>
                        </router-link>
                        <div class="home__table__item__years">
                            <router-link
                                v-for="(fiscal, key) in member.fiscal"
                                v-bind:key="'member_fiscal_' + key"
                                :to="{
                                    path: '/' + member.slug,
                                    query: { year: fiscal.year_of_use },
                                }"
                                class="home__table__item__years__row"
                            >
                                <div class="home__table__item__years__label">
                                    {{ fiscal.year_of_use }}
                                </div>
                                <div class="home__table__item__years__role">
                                    {{
                                        fiscal.goverment_position
                                            | role(fiscal.eu)
                                    }}
                                    •
                                    {{
                                        fiscal.parliament_group
                                            ? fiscal.parliament_group.name
                                            : ""
                                    }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import $ from "jquery";
import PartiesChart from "../components/PartiesChart";
import MemberAutocomplete from "../components/MemberAutocomplete";

const defaultFilters = {
    years: [],
    political_parties: [],
    members: [],
    positions: [],
    parliamentOffices: [],
    sort_by: "alpha",
    parliament_type: [],
};

function loadFilters() {
    const saved = sessionStorage.getItem("memberFilters");
    if (!saved) {
        return defaultFilters;
    }

    try {
        return JSON.parse(saved);
    } catch {
        sessionStorage.removeItem("memberFilters");
        return defaultFilters;
    }
}

export default {
    components: {
        PartiesChart,
        MemberAutocomplete,
    },
    data() {
        return {
            loading: false,
            members: [],
            members_all: [],
            political_parties: [],
            goverment_positions: [],
            parliament_offices: [],
            availableYears: [],
            sort_by: [
                // { label: '↑↓ Αλφαβητικά', value: 'alpha' },
                { label: "Αλφαβητικά", value: "alpha" },
                // { label: 'Υψηλότερο αξίωμα', value: 'highest_position' },
                // { label: 'Χαμηλότερο αξίωμα', value: 'lowest_position' },
                { label: "Υψηλότερο εισόδημα", value: "highest_revenue" },
                { label: "Χαμηλότερο εισόδημα", value: "lowest_revenue" },
            ],
            pagination: {
                loaded: false,
                page: 1,
                parPage: 20,
            },
            memberFilters: loadFilters(),
            top10: {
                revenue: [],
                loans: [],
                deposits: [],
                properties: [],
            },
            top10options: [
                {
                    value: "revenue",
                    label: "Top-10 βουλευτών με υψηλότερο εισόδημα",
                },
                {
                    value: "properties",
                    label: "Top-10 βουλευτών με περισσότερα ακίνητα",
                },
                {
                    value: "loans",
                    label: "Top-10 βουλευτών με υψηλότερη αξία δανείων",
                },
                {
                    value: "deposits",
                    label: "Top-10 βουλευτών με υψηλότερη αξία καταθέσεων",
                },
            ],
            activeTop10: {
                label: "",
                value: "revenue",
                year: "",
                data: [],
            },
            parties_average: null,
            active_parties_avg: {
                year: null,
                value: "revenue_average",
                label: "Μέσο εισόδημα βουλευτή ανά κοινοβ. ομάδα",
            },
            parties_average_options: [
                {
                    value: "revenue_average",
                    label: "Μέσο εισόδημα βουλευτή ανά κοινοβ. ομάδα",
                },
                {
                    value: "properties_average",
                    label: "Μέσος αριθμός ακινήτων βουλευτή ανά κοινοβ. ομάδα",
                },
                {
                    value: "loans_average",
                    label: "Μ.Ο. αξίας δανείων βουλευτή ανά κοινοβ. ομάδα",
                },
                {
                    value: "deposits_average",
                    label: "Μ.Ο. αξίας καταθέσεων βουλευτή ανά κοινοβ. ομάδα",
                },
            ],
        };
    },
    mounted() {
        this.getData();
        this.$nextTick(function () {
            this.initDropdownUI();
        });
        this.activeTop10.label = this.top10options[0].label;
        window.addEventListener("scroll", this.loadMoreMembers);
    },

    methods: {
        resetFilters() {
            sessionStorage.removeItem("memberFilters");
            Object.assign(this.memberFilters, defaultFilters);
        },

        filterSortby(value) {
            if (
                (!this.memberFilters.years.length ||
                    this.memberFilters.years.length > 1) &&
                (value == "highest_revenue" || value == "lowest_revenue")
            ) {
                return false;
            }
            return true;
        },

        positionGroupChechbox(e, group) {
            if (e.target.checked) {
                group.positions.forEach((s_group) => {
                    this.memberFilters.positions.push(s_group.id);
                });
            } else {
                let array = this.memberFilters.positions;
                group.positions.forEach((s_group) => {
                    array = array.filter((e) => e !== s_group.id);
                });
                this.memberFilters.positions = array;
            }
        },

        initDropdownUI() {
            $(".drop-down-filter .toggle").click(function (e) {
                e.stopPropagation();
                $(this).parent().toggleClass("open");
            });
            $(".drop-down-filter ul li input").click(function (e) {
                // e.preventDefault();
                e.stopPropagation();
                $(this).parent().parent().parent().removeClass("open");
            });
            $(".drop-down-filter label, .drop-down-filter input").click(
                function (e) {
                    e.stopPropagation();
                }
            );
            $(document).click(function () {
                $(".drop-down-filter").removeClass("open");
            });
            $(".drop-down-filter").on(
                "click",
                ".drop-down-with-label__toggle",
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).parent().find(".submenu").slideToggle();
                    $("i", this).toggleClass("fa-chevron-down fa-chevron-up");
                }
            );
        },

        setActivePartyAvg(option) {
            this.active_parties_avg.value = option.value;
            this.active_parties_avg.label = option.label;
        },
        setActivePartyYear(year) {
            this.active_parties_avg.year = year;
        },

        setTop10(option) {
            this.activeTop10.label = option.label;
            this.activeTop10.value = option.value;
            this.activeTop10.data =
                this.top10[option.value][this.activeTop10.year];
        },

        setTop10Year(year) {
            this.activeTop10.year = year;
            this.activeTop10.data =
                this.top10[this.activeTop10.value][this.activeTop10.year];
        },

        top10BarWidth(value) {
            const min = Math.min(
                ...this.activeTop10.data.map((item) =>
                    item.properties_count ? item.properties_count : item.total
                )
            );
            const max = Math.max(
                ...this.activeTop10.data.map((item) =>
                    item.properties_count ? item.properties_count : item.total
                )
            );
            const width = ((value - min) * 100) / (max - min) / 3 + 66.7; //min width 50%
            return width;
        },

        getData() {
            this.loading = true;
            const csrfToken = document.head.querySelector(
                'meta[name="csrf-token"]'
            ).content;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
            axios
                .get("/api/home", {
                    data: "this.filters",
                })
                .then((response) => {
                    this.parties_average = response.data.parties_average;
                    // this.active_parties_avg = this.parties_average['2018'];
                    this.members = response.data.members;
                    this.members_all = response.data.members_filters;
                    this.goverment_positions =
                        response.data.goverment_positions;
                    this.parliament_offices = response.data.parliament_offices;
                    this.active_parties_avg.year = response.data.activeYear;
                    if (!this.memberFilters.years.length) {
                        this.memberFilters.years.push(response.data.activeYear);
                    }
                    this.top10 = response.data.top10;
                    this.activeYear = response.data.activeYear;
                    this.activeTop10.year = response.data.activeYear;
                    this.availableYears = response.data.years.reverse();
                    this.activeTop10.data =
                        this.top10["revenue"][this.activeTop10.year];
                    this.political_parties = response.data.parliament_groups;
                    this.loading = false;
                    this.filterMembers();
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },

        paginate(members) {
            const to = this.pagination.page * this.pagination.parPage;
            this.pagination.loaded = true;
            return members.slice(0, to);
        },

        loadMoreMembers() {
            const documentAtBottom =
                document.documentElement.scrollTop + window.innerHeight + 300 >=
                document.documentElement.scrollHeight;
            if (documentAtBottom) {
                this.pagination.page++;
            }
        },

        filterMembers() {
            sessionStorage.setItem(
                "memberFilters",
                JSON.stringify(this.memberFilters)
            );
            this.loading = true;
            const csrfToken = document.head.querySelector(
                'meta[name="csrf-token"]'
            ).content;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
            axios
                .post("/api/home/members", {
                    data: this.memberFilters,
                })
                .then((response) => {
                    this.members = response.data.members;
                    this.pagination.page = 1;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },

        selectAllMemberYears(e) {
            this.memberFilters.years = [];
        },
        selectAllParties(e) {
            this.memberFilters.political_parties = [];
        },
        selectAllMembers(e) {
            this.memberFilters.members = [];
        },
        selectAllParliamentTypes(e) {
            this.memberFilters.parliament_type = [];
        },
        selectAllPositions(e) {
            this.memberFilters.positions = [];
            // if(e.target.checked) {
            //   this.memberFilters.positions = []
            //   this.goverment_positions.forEach( (position)  =>{
            //     this.memberFilters.positions.push(position.id);
            //   });
            // } else {
            //   this.memberFilters.positions = []
            // }
        },
        selectAllParliamentOffices() {
            this.memberFilters.parliamentOffices = [];
        },
        getProfileImage(profile_image) {
            if (profile_image != " ") {
                return profile_image;
            }
            return "/images/default_profile_image_black.svg";
        },
    },
    destroyed() {
        window.removeEventListener("scroll", this.loadMoreMembers);
    },

    computed: {
        displayedMembers() {
            const _members = this.members;
            if (this.memberFilters.sort_by == "highest_revenue") {
                _members.sort(
                    (a, b) =>
                        b.fiscal[0].total_revenue - a.fiscal[0].total_revenue
                );
            } else if (this.memberFilters.sort_by == "lowest_revenue") {
                _members.sort(
                    (a, b) =>
                        a.fiscal[0].total_revenue - b.fiscal[0].total_revenue
                );
            }
            return this.paginate(_members);
        },
    },

    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = "πόθεν έσχες - vouliwatch";
            },
        },
        memberFilters: {
            deep: true,
            handler() {
                this.filterMembers();
            },
        },
        loading: {
            handler() {
                this.$emit("updateLoader", this.loading);
            },
        },
    },

    filters: {
        role: function (role, eu) {
            if (role) {
                return role.name;
            }
            if (eu) {
                return "ΕΥΡΩΒΟΥΛΕΥΤΗΣ";
            }
            return "ΒΟΥΛΕΥΤΗΣ";
        },
        arrayToString: function (array, primary = "Όλα") {
            if (array.length) {
                return array.join();
            } else {
                return primary;
            }
        },
        arrayToStringPG(array, political_group_position) {
            if (array.length) {
                let positions_array = [];
                political_group_position.forEach((group) => {
                    group.positions.forEach((pos) => {
                        positions_array.push(pos);
                    });
                });
                const tmp_arr = positions_array.filter(({ id }) =>
                    array.includes(id)
                );
                let result = tmp_arr.map((a) => a.name);
                return result.join();
            } else {
                return "Όλα";
            }
        },
        arrayToStringPP(array, political_parties) {
            if (array.length) {
                const tmp_arr = political_parties.filter(({ id }) =>
                    array.includes(id)
                );
                let result = tmp_arr.map((a) => a.name);
                return result.join();
            } else {
                return "Όλα";
            }
        },
        arrayToStringMember(array, political_parties) {
            if (array.length) {
                const tmp_arr = political_parties.filter(({ id }) =>
                    array.includes(id)
                );
                let result = tmp_arr.map(
                    (a) => a.first_name + " " + a.last_name
                );
                return result.join();
            } else {
                return "Όλοι";
            }
        },
        arrayToStringSort(s_value, sort_by) {
            const valObj = sort_by.filter(function (elem) {
                if (elem.value == s_value) return elem.label;
            });
            if (valObj.length > 0) {
                return valObj[0].label;
            } else {
                return "undefined";
            }
        },
    },
};
</script>
